import React from 'react';
import html2pdf from 'html2pdf.js';

const IDCardSection = ({ model, portalSettings }) => {
    //env  Vars
    const psm = portalSettings || {};

    const logoPath = `https://insuranceservices.actmanre.com/AMRImages/${psm.groupCode}/ID_${psm.companyLogo}`;

    const handlePrintPDF = () => {
        
        const element = document.getElementById('printable-id-card');
        element.style.transform = 'scale(0.8)';
        element.style.transformOrigin = 'top left';
        const options = {
            margin: 0, // half inch margin around paper
            filename: 'IDCard.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2},
            jsPDF: {
                unit: 'in',
                format: 'letter',  // standard 8.5 x 11 inch paper
                orientation: 'portrait',
            }
        };

        html2pdf().set(options).from(element).save().then(() => {
            element.style.transform = '';
            element.style.transformOrigin = '';
        });
    };

    return (
        <div className="idCardSection">
            <div id="printable-id-card">
                {/* Front */}
                <div className="idCardFront">
                    <div className="idCardFrontHeader">
                        <img
                            src={`${logoPath}`}
                            alt="IDCardLogo2"
                        />
                        <div className="idCardAddress">
                            <p>{model.idCardSection.addressLine1}</p>
                            <p>{model.idCardSection.addressLine2}</p>
                            <p>{model.idCardSection.addressLine3}</p>
                        </div>
                    </div>

                    {/* Front lines */}
                    {[...Array(10)].map((_, i) => (
                        <p key={`front-${i}`}>{model.idCardSection[`frontLine${i + 1}`] || '\u00A0'}</p>
                    ))}
                </div>

                {/* Back */}
                <div className="idCardBack">
                    <div className="idCardBackImages">
                        <img src={`${logoPath}`} alt="IDCardLogo2" />
                        {model?.idCardSection?.hasUSAMCO && (
                            <img
                                src={`https://insuranceservices.actmanre.com/AMRImages/USAMCO/LogoUSAMCO.png`}
                                alt="USAMCO Logo"
                            />
                        )}
                    </div>

                    {[...Array(10)].map((_, i) => (
                        <p key={`back-${i}`}>{model.idCardSection[`backLine${i + 1}`] || '\u00A0'}</p>
                    ))}
                </div>
            </div>

            <div className="baseButton" onClick={handlePrintPDF}>
                Download as PDF
            </div>
        </div>
    );
};

export default IDCardSection;
